import Icon, { Icons } from '@/presentation/components/elements/Icon';
import VaultIcon from '@/presentation/components/elements/VaultIcon';
import { Token, addressEqual } from 'nftx.js';
import { useFormatter } from 'use-intl';
import { formatEther } from 'viem';

const itemStyles =
  'w-full flex items-center hover:bg-gray-200 px-4 py-1.5 text-gray-800';
const selectedStyles = 'opacity-50 cursor-default';

export const VaultToken = ({
  id,
  name,
  token,
  onClick,
  vaultId,
  balance,
  symbol,
}: Token & {
  token: string;
  onClick: () => void;
  vaultId: string;
  balance?: bigint;
}) => {
  const { number } = useFormatter();
  const selected = addressEqual(id, token);

  return (
    <li>
      <button
        type="button"
        className={`${itemStyles} ${selected ? selectedStyles : ''}`}
        onClick={onClick}
      >
        <VaultIcon vaultId={vaultId} className="w-10 h-10 mr-2 flex-none" />
        <div className="flex flex-col items-start">
          <h4 className="font-medium">{symbol}</h4>
          <div className="text-sm text-gray-500">{name}</div>
        </div>
        <div className="ml-auto">
          {balance != null
            ? number(Number(formatEther(balance || 0n)), {
                maximumSignificantDigits: 4,
                minimumSignificantDigits: 1,
              })
            : null}
        </div>
        {selected && (
          <Icon name={Icons.CHECK} size={20} className="ml-2 text-pink-500" />
        )}
      </button>
    </li>
  );
};

export default VaultToken;
